import { MessageOutlined, ScissorOutlined, VideoCameraOutlined } from '@ant-design/icons';
import { TabDefinition } from '../../../shared/components/Tab/Tabs';
import { Chat } from '../Chat';
import { Badge, Space, Tooltip } from 'antd';
import { Transcript } from '../Transcript';
import { CreateClipV2 } from '../CreateClipV2';

export const chatTab: TabDefinition = {
  children: <Chat />,
  key: 'chat',
  label: (
    <Space>
      <MessageOutlined style={{ fontSize: '16px' }} />
      Chat text from zoom
    </Space>
  ),
};

export const transcriptTab: TabDefinition = {
  children: <Transcript />,
  key: 'transcript',
  label: (
    <Space>
      <VideoCameraOutlined style={{ fontSize: '16px' }} />
      Video transcript
    </Space>
  ),
};

export const createClipTab: TabDefinition = {
  children: <CreateClipV2 />,
  key: 'createClip',
  label: (
    <Tooltip title="Currently in Beta — share any and all feedback to concierge@update.ai">
      <Badge dot color="red">
        <Space>
          <ScissorOutlined style={{ fontSize: '16px' }} />
          Create Clip
        </Space>
      </Badge>
    </Tooltip>
  ),
};
